import type { Router } from 'vue-router';

import type { MappedRecommendedOffer } from '@/features/favorites';

import { amplitudeEventsConfig } from '@/shared/config';

/**
 * Opens the SERP for the saved search behind a recommended offer.
 */
export function navigateToRecommendedOffer(
  router: Router,
  offer: MappedRecommendedOffer,
) {
  router.push({
    name: 'OffersResults',
    params: {
      hashCode: offer.search_query,
      source: amplitudeEventsConfig.SERP_OPEN_SOURCE.RECOMMENDED_OFFERS,
    },
  });
}
